"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Check = require("react-icons/lib/md/check");
var Trash = require("react-icons/lib/md/delete");
var Repeat = require("react-icons/lib/md/replay");
var ItemLike_1 = require("./ItemLike");
var ItemName_1 = require("./ItemName");
require("./style/Item.css");
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showButtons: false };
        return _this;
    }
    Item.prototype.render = function () {
        var _this = this;
        var _a = this.props, detailed = _a.detailed, details = _a.details, highlighted = _a.highlighted, href = _a.href, item = _a.item, nameIcon = _a.nameIcon, onEditName = _a.onEditName, setCurrentItem = _a.setCurrentItem;
        return (React.createElement(ItemLike_1.default, { onClick: detailed ? undefined : function () { return setCurrentItem(item); }, onMouseOver: function () { return _this.setState({ showButtons: true }); }, onMouseOut: function () { return _this.setState({ showButtons: false }); } },
            React.createElement("div", { className: "Item-header" },
                React.createElement(ItemName_1.default, { highlighted: highlighted, href: href, icon: nameIcon, onEdit: onEditName, text: item.name }),
                this.buttons),
            detailed && details));
    };
    Object.defineProperty(Item.prototype, "buttons", {
        get: function () {
            var _a = this.props, detailed = _a.detailed, done = _a.done, item = _a.item, removeItem = _a.removeItem, toggleItemState = _a.toggleItemState;
            var buttons = [];
            if (!done || detailed) {
                buttons.push(React.createElement("div", { key: "toggleState", className: "Item-button", onClick: function (event) {
                        toggleItemState(item);
                        event.stopPropagation();
                    } }, done ? React.createElement(Repeat, null) : React.createElement(Check, null)));
            }
            if (!done && this.props.buttons) {
                buttons.push.apply(buttons, __spread(this.props.buttons));
            }
            if (done || detailed) {
                buttons.push(React.createElement("div", { key: "trash", className: "Item-button", onClick: function (event) {
                        removeItem(item);
                        event.stopPropagation();
                    } },
                    React.createElement(Trash, null)));
            }
            return (React.createElement("div", { className: "Item-buttons" + (this.state.showButtons ? "" : "-hidden") }, buttons));
        },
        enumerable: true,
        configurable: true
    });
    return Item;
}(React.Component));
exports.default = Item;



//////////////////
// WEBPACK FOOTER
// ./src/component/Item.tsx
// module id = 90
// module chunks = 0